@if (router.url !== '/') {
    <div class="special-offer-container">
        @if (discountedMaterials.length > 0) {
            <div class="published">
                <div class="pub-container">
                    <div class="pubb">
                        <h3>{{ homeConfig.name | uppercase }}</h3>
                    </div>
                    <div class="easter-discount-text">
                        <b>
                            {{ 'shoppingCart.freeDelivery' | translate }}
                            <a href="https://jogkodex.hu/jsz/2024_13_torveny_6486371?ts=kozlony#pl9%C2%A7" target="_blank"
                                ><mat-icon>info</mat-icon></a
                            >
                        </b>
                    </div>
                </div>
            </div>
        }
        @if (discountedMaterials.length > 0) {
            <div class="materials-container-special-offer">
                <div class="material-container-published">
                    <div class="books-container">
                        @for (product of discountedMaterials; track product) {
                            <app-product-preview [product]="product" (addToCart)="addToCartDiscountedBook($event)" />
                        }
                    </div>
                </div>
            </div>
        }
    </div>
}

@if (router.url === '/' && discountedMaterials.length > 0) {
    <div class="special-offer-container">
        <div class="published">
            <pf-offer-header
                [title]="'specialOffer.discountedBooks'"
                [translateTitle]="true"
                [lines]="offerLinesActive() ? offerLines() : []"
            />
        </div>
        <div class="materials-container-special-offer">
            <div class="material-container-published">
                <div class="books-container">
                    @for (product of discountedMaterials; track product) {
                        <app-product-preview [product]="product" (addToCart)="addToCartDiscountedBook($event)" />
                    }
                </div>
            </div>
        </div>
    </div>
}
